import styled from "@emotion/styled";
import InputBlurChange from "metabase/components/InputBlurChange";

export const ColumnInput = styled(InputBlurChange)`
  width: auto;
`;
